var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector } from '@angular/core';
import { GmapsHelpers } from '../gmaps-helpers.model';
import { AgencyService } from '../../api/agency.service';
import { GtagService } from './../../analytics/gtag.service';
import { FbqService } from './../../analytics/fbq.service';
import { GmapsInterfaceComponent } from '../gmaps-interface/gmaps-interface.component';
import { isPlatformBrowser } from '@angular/common';
var GoogleMapComponent = /** @class */ (function (_super) {
    __extends(GoogleMapComponent, _super);
    function GoogleMapComponent(injector, gtagService, fbqService, agencyService, platformId, window) {
        var _this = _super.call(this, injector) || this;
        _this.gtagService = gtagService;
        _this.fbqService = fbqService;
        _this.agencyService = agencyService;
        _this.platformId = platformId;
        _this.window = window;
        _this.zoom = 16;
        _this.travelModes = [];
        _this.customMarkers = [];
        _this.isHidden = false;
        return _this;
    }
    GoogleMapComponent.prototype.clickedMarker = function (latitude, longitude) {
        if (isPlatformBrowser(this.platformId) && this.window) {
            this.window.open('https://maps.google.com?daddr='
                + latitude + ','
                + longitude + '&amp;ll=');
            this.gtagService.sendEvent('contact', 'click', 'maps_click');
            this.fbqService.sendEvent('Lead', { content_name: 'maps_click', content_category: 'click' });
        }
    };
    GoogleMapComponent.prototype.updateDirectionsPath = function ($event) {
        if (this.travelModes && this.travelModes.length)
            this.updatePath($event.coords.lat, $event.coords.lng);
    };
    return GoogleMapComponent;
}(GmapsHelpers));
export { GoogleMapComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/google-map/google-map.component.ts.pre-build-optimizer.js